import { HttpEventType } from '@angular/common/http';
import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FileDto } from 'src/app/data/models/dto/file.dto';
import { FileService } from 'src/app/data/services/file.service';
import { FileUtils } from 'src/app/data/utils/file.utils';

@Component({
  selector: 'app-file-upload-item',
  templateUrl: './file-upload-item.component.html',
  styleUrls: ['./file-upload-item.component.scss'],
})
export class FileUploadItemComponent implements OnInit, OnChanges {
  @Input() file!: File | null;
  @Input() filePathOldStructure: string = '';

  @Output() onFail = new EventEmitter<boolean>();
  @Output() onStop = new EventEmitter<boolean>();
  @Output() onSuccess = new EventEmitter<FileDto>();
  fileUploaded: FileDto | null = null;

  uploadInProgress = true;
  uploadError = false;
  fileStatus = 'in progress ...';
  stopUpload: Subject<boolean>;
  progressPercent = 0;
  completedOrStopped = false;

  pdfIcon = '../../../../assets/icons/pdf-img.png';
  imageIcon = '../../../../assets/icons/image-img.png';
  iconType = '';
  screenWidth = 0;
  screenHeight = 0;

  @HostListener('window:resize', ['$event'])
  getScreenSize() {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
  } 

  constructor(private fileService: FileService, private fileUtils: FileUtils) {
    this.stopUpload = new Subject<boolean>();
    this.stopUpload.next(false);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.uploadFile();
  }
  ngOnInit(): void {
    this.getScreenSize();
  }

  private uploadFile() {
    this.uploadInProgress = true;
    this.uploadError = false;
    if (this.file) {
      const fileExtension = this.fileUtils.fileExtension(this.file.name);
      this.iconType = fileExtension === 'PDF' ? this.pdfIcon : this.imageIcon;
      if (this.filePathOldStructure && this.filePathOldStructure != '')
        this.uploadOldStructure();
      else
        this.uploadNewStructure();
    }
  }

  private uploadOldStructure(): void {
    try {
      this.fileService
        .uploadOldStructure([this.file!], this.filePathOldStructure)
        .pipe(takeUntil(this.stopUpload!.asObservable()))
        .subscribe(
          (event) => {
            if (event.type === HttpEventType.UploadProgress) {
              this.progressPercent = Math.round(
                (100 * event.loaded) / event.total!
              );
            } else if (event.type === HttpEventType.Response) {
              if (event.body?.toString() == 'upload complete')
                this.uploadCompleted(this.file?.name!);
            }
          },
          (error) => {
            console.log(error);
            this.errorStatus();
          }
        );
    } catch (error) {
      console.log(error);
      this.errorStatus();
    }
  }  

  private uploadNewStructure(): void {
    try {
      this.fileService
        .uploadNewStructure([this.file!])
        .pipe(takeUntil(this.stopUpload!.asObservable()))
        .subscribe(
          (event) => {
            if (event.type === HttpEventType.UploadProgress) {
              this.progressPercent = Math.round(
                (100 * event.loaded) / event.total!
              );
            } else if (event.type === HttpEventType.Response) {
              this.uploadCompleted(event.body?.success[0]!);
            }
          },
          (error) => {
            console.log(error);
            this.errorStatus();
          }
        );
    } catch (error) {
      console.log(error);
      this.errorStatus();
    }
  }

  private uploadCompleted(uploadedFile: string | FileDto) {
    let emitFile: FileDto;
    if (typeof uploadedFile === 'string') {
      emitFile = new FileDto('', '', '', uploadedFile);
    } else {
      emitFile = uploadedFile;
    }
    this.completedOrStopped = true;
    this.uploadInProgress = false;
    this.fileStatus = 'concluído';
    this.onSuccess.emit(emitFile);
  }

  private errorStatus() {
    this.uploadInProgress = false;
    this.uploadError = true;
    this.fileStatus = 'falha ao carregar';
    this.stopUpload.next(true);
    this.onFail.emit(true);
  }

  fileSize(file: File) {
    return file ? this.fileUtils.formatBytes(file.size) : '';
  }

  onStopUploadClick() {
    this.completedOrStopped = true;    
    this.stopUpload.next(true);
    this.uploadInProgress = false;
    this.uploadError = false;
    this.fileStatus = 'cancelado';
    this.onStop.emit(true);
  }

  onTryAgainClick() {
    this.onFail.emit(false);
    this.uploadFile();
  }
}
